import { workloadStatusesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { alert } from "services/alert";

const GenerateReportTask = ({ status, taskKey, history, location, reportType }) => {
    useEffect(() => {
        if (status === workloadStatusesEnum.Faulted) {
            alert({
                type: "error",
                title: "Ошибка",
                message: <small>При формировании отчета произошла ошибка</small>,
            });
        } else if (location.pathname !== paths.reportsShow(reportType)) {
            alert({
                type: "success",
                title: "Отчет сформирован",
                timeOut: 0,
                message: <small>Нажмите, чтобы открыть его</small>,
                callback: () => {
                    history.push(`${paths.reportsShow(reportType)}?taskKey=${taskKey}`);
                },
            });
        }
    }, []);
    if (status === workloadStatusesEnum.Faulted) {
        return <span className="text-danger">Ошибка</span>;
    } else {
        return <Link to={`${paths.reportsShow(reportType)}?taskKey=${taskKey}`}>Открыть</Link>;
    }
};

export default GenerateReportTask;
